import { Typography } from '@mui/material';

export function Empty({ whichAnomaly }: { whichAnomaly: string }) {
  return (
    <Typography component='div' textAlign='center' variant='noData'>
      There Are No {whichAnomaly} Anomalies
    </Typography>
  );
}
